import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Zap } from 'lucide-react';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/why-africa', label: 'Why Africa' },
  { to: '/ecosystem', label: 'Ecosystem' },
  { to: '/partners', label: 'Partners' },
  { to: '/climate-impact', label: 'Impact' },
  { to: '/opportunity', label: 'Opportunity' },
  { to: '/team', label: 'Team' },
  { to: '/invest', label: 'Invest' },
  { to: '#', label: 'News' },
];

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <>
      <nav className={`fixed inset-x-0 top-0 z-[1000] px-8 transition-all duration-300 ${scrolled ? 'border-b border-white/10 bg-bg-primary/95 backdrop-blur-xl' : ' text-white bg-bg-dark'}`}>
        <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="flex h-9 w-9 animate-glow items-center justify-center rounded-[10px] bg-gradient-to-br from-accent-green to-accent-greenDim shadow-[0_0_20px_rgba(0,232,123,0.4)]">
              <Zap size={18} className="text-bg-primary" strokeWidth={2.5} />
            </div>
            <span className="font-heading text-[1.1rem] font-extrabold">
              AZURA <span className="text-accent-green">MOBILITY</span>
            </span>
          </Link>

          <div className="hidden items-center gap-1 min-[901px]:flex">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`whitespace-nowrap rounded-lg px-3 py-1.5 text-[0.82rem] font-medium transition duration-200 hover:bg-white/50 hover:text-text-primary ${
                  location.pathname === link.to ? 'bg-white/30 text-secondary' : 'text-text-secondary'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="block cursor-pointer border-0 bg-transparent text-text-primary min-[901px]:hidden"
            aria-label="Toggle navigation"
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="fixed inset-x-0 bottom-0 top-[72px] z-[999] flex flex-col gap-2 bg-bg-primary/95 p-8 backdrop-blur-xl min-[901px]:hidden">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`rounded-xl border px-5 py-3.5 font-heading text-lg font-semibold ${
                location.pathname === link.to
                  ? 'border-accent-green/25 bg-accent-green/10 text-accent-green'
                  : 'border-white/10 bg-bg-card text-text-primary'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </>
  );
};

export default Navbar;
